import * as MutationTypes from '../mutation-types'
import { errorResponseHelper } from '@/helpers'
import { underLoadingFunction } from '../helpers/under-loading'

import AuthService from '@/services/auth.service'

import {
  clearToken,
  getAccessData
} from '@/auth'

const client = {
  'background-color': '',
  'background-button': '',
  'text-primary-color': '',
  'text-secondary-color': '',
  'logo': '',
  'name': '',
  'template': '',
  'transaction-permition': false,
  'block-desktop': false,
  'text-initial-description': '',
  'text-initial-title': '',
  'text-initial-buttom': '',
  'text-completed-title': '',
  'text-completed-description': '',
  'text-completed-description-redirect': '',
  'text-button-completed-action-redirect': ''
}

const state = {
  device: 'desktop',
  isLoading: false,
  // Nº de telas que exibem o próprio indicador de carregamento e por isso
  // suprimem o overlay global. É contador, e não booleano, porque a troca
  // entre dois <loading-preparation> pode montar o novo antes de destruir o
  // antigo — com booleano o overlay voltaria a piscar no meio da transição.
  globalLoadingSuppressors: 0,
  tituloLoading: '',
  header: {
    title: { title: '', icon: '', align: '' },
    right: true,
    hidden: true
  },
  client: {
    'background-color': '',
    'background-button': '',
    'text-primary-color': '',
    'text-secondary-color': '',
    'logo': '',
    'name': '',
    'template': '',
    'transaction-permition': false,
    'block-desktop': false,
    'text-initial-description': '',
    'text-initial-title': '',
    'text-initial-buttom': '',
    'text-completed-title': '',
    'text-completed-description': '',
    'text-completed-description-redirect': '',
    'text-button-completed-action-redirect': ''
  },
  flow: [],
  riskDevice: false,
  riskDeviceId: '',
  retryFaceCapture: 1
}

const mutations = {
  [MutationTypes.TOGGLE_DEVICE](mutationState, device) {
    mutationState.device = device
  },
  [MutationTypes.SET_LOADING](mutationState, isLoading) {
    mutationState.isLoading = isLoading || false
  },
  [MutationTypes.SET_TEXT_LOADING](mutationState, text) {
    mutationState.tituloLoading = text
  },
  [MutationTypes.SUPPRESS_GLOBAL_LOADING](mutationState, active) {
    mutationState.globalLoadingSuppressors = Math.max(
      0,
      mutationState.globalLoadingSuppressors + (active ? 1 : -1)
    )
  },
  [MutationTypes.SET_CLIENT]: (mutationState, client) => {
    mutationState.client = client
  },
  [MutationTypes.UPDATE_HEADER]: (mutationState, header) => {
    mutationState.header = header
  },
  [MutationTypes.SET_FLOW]: (mutationState, flow) => {
    mutationState.flow = flow
  },
  [MutationTypes.RISK_DEVICE]: (mutationState, riskDevice) => {
    mutationState.riskDevice = riskDevice
  },
  [MutationTypes.RISK_DEVICE_ID]: (mutationState, riskDeviceId) => {
    mutationState.riskDeviceId = riskDeviceId
  },
  [MutationTypes.RETRY_FACE_CAPTURE]: (mutationState) => {
    mutationState.retryFaceCapture++
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit(MutationTypes.TOGGLE_SIDEBAR)
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit(MutationTypes.CLOSE_SIDEBAR, withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit(MutationTypes.TOGGLE_DEVICE, device)
  },
  setSize({ commit }, size) {
    commit(MutationTypes.SET_SIZE, size)
  },
  setLoading({ commit }, status) {
    commit(MutationTypes.SET_LOADING, status)
  },
  setTextLoading({ commit }, text) {
    commit(MutationTypes.SET_TEXT_LOADING, text)
  },
  suppressGlobalLoading({ commit }, active) {
    commit(MutationTypes.SUPPRESS_GLOBAL_LOADING, active)
  },
  updateHeader({ commit }, header) {
    commit(MutationTypes.UPDATE_HEADER, header)
  },
  setClient({ commit }, data) {
    commit(MutationTypes.SET_CLIENT, data)
  },
  setFlowTransaction({ commit }, data) {
    commit(MutationTypes.SET_FLOW, data)
  },
  setRiskDevice({ commit }, data) {
    commit(MutationTypes.RISK_DEVICE, data)
  },
  setRiskDeviceId({ commit }, data) {
    commit(MutationTypes.RISK_DEVICE_ID, data)
  },
  setRetryFaceCapture({ commit }) {
    commit(MutationTypes.RETRY_FACE_CAPTURE)
  },
  async resetProcessUser({ commit }, data) {
    commit(MutationTypes.SET_CLIENT, client)
    const keyAccess = await getAccessData()
    clearToken()
    return keyAccess
  },
  validStepTransaction: underLoadingFunction(async({ commit }, payload) => {
    try {
      const { data } = await AuthService.validStepTransaction(payload)
      return { success: true, data }
    } catch (error) {
      errorResponseHelper.display(error)
      return { success: false, error }
    }
  })
}

export default {
  state,
  mutations,
  actions
}
